module.exports = function (obj, key) {
  return obj.hasOwnProperty(key);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/object/has.js
// module id = 103
// module chunks = 0